import { render } from "./TraineeTaskAssessmentModal.vue?vue&type=template&id=13166657&scoped=true"
import script from "./TraineeTaskAssessmentModal.vue?vue&type=script&lang=js"
export * from "./TraineeTaskAssessmentModal.vue?vue&type=script&lang=js"

import "./TraineeTaskAssessmentModal.vue?vue&type=style&index=0&id=13166657&scoped=true&lang=css"
/* custom blocks */
import block0 from "./TraineeTaskAssessmentModal.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13166657"]])

export default __exports__